import { z } from 'zod';

import { PropertyId } from '../BrandedIds';
import { zodDateOrString } from '../utils';
import { BaseLoanEvent } from './BaseLoanEvent';

export const AddAppraisalOrderEvent = BaseLoanEvent.extend({
  type: z.literal('addAppraisalOrder'),
  propertyId: PropertyId,
  date: zodDateOrString,
  vendorName: z.string(),
});

export type AddAppraisalOrderEvent = z.infer<typeof AddAppraisalOrderEvent>;
